import { useState } from 'react';
import styled from 'styled-components';
import { HGrid, Text, Checkbox as TombacCheckbox, VGrid, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Checkbox = styled(TombacCheckbox).withConfig({
  displayName: "ProductCheckbox__Checkbox"
})(["&&& > [class|='Checkbox__StyledCheckbox']{background-color:transparent;&:before{border-color:", ";}}"], ({
  error
}) => error ? tombac.color('danger', 400) : 'none');
const ContainingLabel = styled.label.withConfig({
  displayName: "ProductCheckbox__ContainingLabel"
})(["border:", " solid;border-radius:20px;background-color:", ";display:grid;gap:", ";grid-auto-flow:row;outline:", " solid ", ";outline-width:", ";padding:", ";transition:0.1s ease-out;border-color:", ";transition-property:background-color,border-color,outline-width;@media (max-width:", "){overflow-wrap:word-break;}"], tombac.unit(1), ({
  checked
}) => checked ? tombac.color('accent', 100) : tombac.color('neutral', 100), tombac.space(1), tombac.space(0.5), tombac.color('neutral', 300), ({
  focused
}) => focused ? tombac.space(0.5) : 0, tombac.space(2, 2, 2), ({
  checked
}) => checked ? tombac.color('accent', 600) : tombac.color('neutral', 400), tombac.unit(1023));
const Description = styled(Text).withConfig({
  displayName: "ProductCheckbox__Description"
})(["color:", ";"], ({
  checked
}) => checked ? tombac.color('accent', 500) : undefined);
const Limits = styled.div.withConfig({
  displayName: "ProductCheckbox__Limits"
})(["", ""], tombac.text({
  color: tombac.color('accent', 400),
  fontSize: 12,
  fontWeight: 500
}));
const Name = styled.span.withConfig({
  displayName: "ProductCheckbox__Name"
})(["", ""], tombac.altText({
  fontSize: 16,
  fontWeight: 700
}));
const Tagline = styled.div.withConfig({
  displayName: "ProductCheckbox__Tagline"
})(["", ";text-transform:uppercase;"], tombac.text({
  color: tombac.color('accent', 500),
  fontSize: 12,
  fontWeight: 700
}));
const ProductCheckbox = ({
  checked,
  description,
  limits,
  logo: Logo,
  name,
  onBlur,
  onChange,
  tagline,
  error
}) => {
  const [focused, setFocused] = useState(false);
  const handleBlur = event => {
    setFocused(false);
    if (onBlur) onBlur(event);
  };
  const handleFocus = () => {
    setFocused(true);
  };
  return /*#__PURE__*/_jsxs(ContainingLabel, {
    error: error,
    checked: checked,
    focused: focused,
    "data-sentry-element": "ContainingLabel",
    "data-sentry-component": "ProductCheckbox",
    "data-sentry-source-file": "ProductCheckbox.tsx",
    children: [/*#__PURE__*/_jsxs(HGrid, {
      gridTemplateColumns: "max-content 1fr min-content",
      "data-sentry-element": "HGrid",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "HGrid",
      children: [/*#__PURE__*/_jsx(Logo, {
        height: "40",
        width: "40",
        "data-sentry-element": "Logo",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "Logo"
      }), /*#__PURE__*/_jsxs(VGrid, {
        gap: 0.5,
        "data-sentry-element": "VGrid",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "VGrid",
        children: [/*#__PURE__*/_jsx(Tagline, {
          "data-sentry-element": "Tagline",
          "data-sentry-source-file": "ProductCheckbox.tsx",
          "data-sentry-element": "Tagline",
          children: tagline
        }), /*#__PURE__*/_jsx(Name, {
          "data-sentry-element": "Name",
          "data-sentry-source-file": "ProductCheckbox.tsx",
          "data-sentry-element": "Name",
          children: name
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        checked: checked,
        label: false,
        onBlur: handleBlur,
        onChange: onChange,
        onFocus: handleFocus,
        error: error,
        "data-sentry-element": "Checkbox",
        "data-sentry-source-file": "ProductCheckbox.tsx",
        "data-sentry-element": "Checkbox"
      })]
    }), /*#__PURE__*/_jsx(Description, {
      checked: checked,
      size: "s",
      variant: "secondary",
      "data-sentry-element": "Description",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "Description",
      children: description
    }), /*#__PURE__*/_jsx(Limits, {
      "data-sentry-element": "Limits",
      "data-sentry-source-file": "ProductCheckbox.tsx",
      "data-sentry-element": "Limits",
      children: limits.join(' | ')
    })]
  });
};
export default ProductCheckbox;